import React, { useState } from 'react';
import { FadeInUp } from './FadeInUp';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  question: '¿Es un pago único o me van a cobrar todos los meses?',
  answer: 'Es un pago único de $4.990 CLP. No es una suscripción, no hay cargos ocultos ni mensualidades. Una vez que compras, el acceso al Protocolo 7D es tuyo para siempre, incluyendo todas las futuras actualizaciones.'
}, {
  question: '¿Tengo que comprar ingredientes caros o difíciles de hallar?',
  answer: 'Para nada. Todo lo que necesitas lo encuentras en la feria de tu barrio, en el Líder, Jumbo o Unimarc. Son alimentos e ingredientes naturales y económicos que probablemente ya tienes en tu cocina ahora mismo.'
}, {
  question: '¿Cómo recibo el producto después de pagar?',
  answer: 'La entrega es inmediata. Una vez que se procesa tu pago (vía Mercado Pago o Webpay), recibirás un correo electrónico automático con el enlace de acceso directo a tu Guía Digital y todos los bonos. Podrás leerlo en tu celular, tablet o computador al instante.'
}, {
  question: '¿Funciona si tengo más de 40 años o metabolismo lento?',
  answer: '¡Absolutamente! El Protocolo 7D no se basa en el ejercicio extremo ni en pasar hambre, sino en la ciencia de la desinflamación. Está diseñado específicamente para resetear el sistema digestivo, sin importar tu edad o qué tan "lento" sientas tu metabolismo actual.'
}, {
  question: '¿Es una dieta restrictiva donde pasaré hambre?',
  answer: 'No. El enfoque de Vitarutinas es la densidad nutricional. Aprenderás a combinar alimentos para que tu cuerpo se sienta satisfecho y con energía mientras elimina el exceso de líquido y gases. No se trata de comer menos, sino de comer de forma inteligente.'
}, {
  question: '¿Qué pasa si el método no me funciona?',
  answer: 'Estamos tan seguros de los resultados que ofrecemos una Garantía de Satisfacción de 7 Días. Si aplicas el protocolo y sientes que no es para ti, o no ves un cambio en tu ligereza, simplemente escríbenos y te devolvemos el 100% de tu dinero. Sin preguntas, estamos aquí para ayudarte.'
}];
export function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-6 bg-white" data-id="element-217">
      <div className="max-w-3xl mx-auto" data-id="element-218">
        <FadeInUp data-id="element-219">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-12 text-center text-deep-green" data-id="element-220">
            Preguntas Frecuentes
          </h2>
        </FadeInUp>

        <div className="space-y-4" data-id="element-221">
          {FAQS.map((faq, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-222">
              <div className="border border-black/5 rounded-2xl overflow-hidden bg-cream/50" data-id="element-223">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-224">
                  <span className="font-bold text-deep-green pr-4" data-id="element-225">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.2
              }} className="shrink-0 text-sage" data-id="element-226">
                    <ChevronDown className="w-5 h-5" data-id="element-227" />
                  </motion.div>
                </button>
                <AnimatePresence initial={false} data-id="element-228">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-229">
                      <div className="px-6 pb-5 text-charcoal/70 leading-relaxed" data-id="element-230">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeInUp>)}
        </div>
      </div>
    </section>;
}